import React from "react";
import { Check } from "lucide-react";
import { SPORTS } from "../../lib/sports";
import { useI18n } from "../../contexts/I18nContext";

export default function SportPicker({ value = [], onChange, testid = "sport-picker" }) {
  const { lang } = useI18n();
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <div className="grid grid-cols-2 sm:grid-cols-5 gap-2" data-testid={testid}>
      {SPORTS.map((s) => {
        const on = value.includes(s.id);
        return (
          <button type="button" key={s.id} onClick={() => toggle(s.id)} data-testid={`${testid}-${s.id}`}
            className={`relative h-20 rounded-xl overflow-hidden border-2 text-left transition-colors ${on ? "border-pitch" : "border-white/10 hover:border-white/30"}`}>
            <img src={s.img} alt="" className="absolute inset-0 w-full h-full object-cover opacity-50" />
            <span className="absolute inset-0 bg-gradient-to-t from-[#0A1628] to-transparent" />
            <span className="absolute bottom-2 left-2 right-6 text-[11px] font-bold uppercase leading-tight text-white">{lang === "bg" ? s.bg : s.en}</span>
            {on && <span className="absolute top-1.5 right-1.5 w-5 h-5 rounded-full bg-pitch text-white grid place-items-center"><Check className="w-3 h-3" /></span>}
          </button>
        );
      })}
    </div>
  );
}
